import React from "react";

function Footer(props) {
  return <footer id="Footer"></footer>;
}

export default Footer;
